import { isStocksFunnel } from '../common/web/is-stocks-host'
import { checkRedirectURL } from '../common/web/check-url-with-domain'
import {
  getDomainUrl,
  getHostName,
  getINDStockDomainUrl,
  getINDStocksHostName,
} from '@/root/api/url-constants'

// Post login function tailored for STENCIL
export const onLogin = (
  isNew = false,
  encryptedToken = '',
  returnTo = '',
  encryptedRefreshToken = '',
) => {
  const { hostname } = window.location

  // Need to check if needed or not
  // -------------------------------------
  // if landed here via IND Quiz referral, handle it specially
  // const parsedReturnTo = "" // Utils.getPathNameAndQueryParamsFromReturnTo()
  // if (
  //   parsedReturnTo.pathName?.includes('/indpolls') &&
  //   parsedReturnTo.queryParams?.get('gift_code')
  // ) {
  //   const newForIndQuizReferral = !fName
  //   const indQuizReferralRedirectUrl = `${returnTo}&is_new=${newForIndQuizReferral}`
  //   if (newForIndQuizReferral) {
  //     window.localStorage.setItem(
  //       'IND_QUIZ_REFERRAL_REDIRECT_URL',
  //       indQuizReferralRedirectUrl,
  //     )
  //     window.location.href = '/onboarding-l1-sl1'
  //   } else {
  //     window.location.href = indQuizReferralRedirectUrl
  //   }
  //   return
  // }
  // -------------------------------------

  const domain = isStocksFunnel() ? getDomainUrl() : getINDStockDomainUrl()
  console.info('domain', {
    domain,
    stockFunnel: isStocksFunnel(),
    ind: getDomainUrl(),
  })
  const newDomain = isStocksFunnel() ? getINDStockDomainUrl() : getDomainUrl()

  // Global link for authenticating to other domain name like indstocks or indmoney when on authentication is proceeded from any one of them
  const globalLink = `${domain}?token=${encryptedToken}${
    encryptedRefreshToken ? `&refresh_token=${encryptedRefreshToken}` : ''
  }&return_to=${hostname ? `https://${hostname}` : newDomain}`

  try {
    // handling for new user to redirect them to onboarding flow
    if (isNew) {
      const hostName = isStocksFunnel() ? getINDStocksHostName() : getHostName()
      window.location.href = `${domain}?token=${encryptedToken}${
        encryptedRefreshToken ? `&refresh_token=${encryptedRefreshToken}` : ''
      }&return_to=${hostName}/onboarding-l1-sl1`
    } else if (returnTo && returnTo !== 'about:blank') {
      // Return to handling

      if (checkRedirectURL(returnTo) || returnTo.includes('logout')) {
        window.location.href = `${globalLink}${decodeURIComponent('/')}`
      } else if (returnTo.includes('dynamo_id')) {
        window.location.href = `${globalLink}${returnTo}`
      } else {
        window.location.href = `${globalLink}${decodeURIComponent(returnTo)}`
      }
    } else {
      // Default redirection after login
      window.location.href = `${globalLink}${decodeURIComponent('/dashboard')}`
    }
  } catch {
    window.location.href = `${globalLink}${decodeURIComponent('/')} `
  }
}
